import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';

interface Props {
  total: number;
  noun: string;
  selectedCount: number;
  bulkActions: React.ReactNode;
  onDownload: () => void;
  downloading: boolean;
}

export const PendingRequestsHeader = ({ total, noun, selectedCount, bulkActions, onDownload, downloading }: Props) => {
  const { isMobile, isSm } = useCampfireTheme();
  const isCompact = isMobile || isSm;

  return (
    <Box
      style={{
        paddingLeft: isCompact ? '10px' : '25px',
        paddingRight: '10px',
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px',
        flexShrink: 0,
      }}
    >
      <Typography style={{ fontSize: '14px', color: '#333' }}>
        <strong>{total}</strong> {noun}
      </Typography>
      <Box style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        {selectedCount > 0 && (
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <Typography style={{ fontSize: '13px', color: '#646464' }}>
              <strong>{selectedCount}</strong> selected
            </Typography>
            {bulkActions}
          </Box>
        )}
        <Button
          onClick={onDownload}
          disabled={downloading || total === 0}
          startIcon={
            downloading ? <CircularProgress size={12} color='inherit' /> : <GetApp style={{ fontSize: '14px' }} />
          }
          style={{
            backgroundColor: 'transparent',
            color: '#646464',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            padding: '4.5px 12px',
            fontSize: '12px',
            fontWeight: 600,
            textTransform: 'none',
            minWidth: 'auto',
          }}
        >
          Export
        </Button>
      </Box>
    </Box>
  );
};
